import React from 'react';
import styled from 'styled-components';
import { IRatioReportState } from '../../../data/providers/reports/ratioReportProvider';
import { Column } from '../../layout/Column';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import { Notable } from '../../shared/pdf/Notable';
import { EPdfMode, isPdf, shouldInvert } from '../../shared/pdf/Pdf';
import { Graph } from './Graph';

interface IProps {
  reportState: IRatioReportState;
  pdfMode?: EPdfMode;
}

export const GraphCard = (props: IProps): React.ReactElement => {
  return (
    <PdfCardWrapper className='avoid-break' pdf={isPdf(props.pdfMode)}>
      <Notable pdf={isPdf(props.pdfMode)}>
        <Card inverse={shouldInvert(props.pdfMode)}>
          <Column>
            <CardBody withoutFooter>
              <Graph
                results={props.reportState.resultList}
                pdfMode={props.pdfMode}
              />
            </CardBody>
          </Column>
        </Card>
      </Notable>
    </PdfCardWrapper>
  );
};

const PdfCardWrapper = styled.div<{ pdf?: boolean }>`
  flex: 1;
  padding: 2px;
`;
